export default __webpack_public_path__ + "static/media/banner-news.6f29e63b.png";